export var CombinedRole;
(function (CombinedRole) {
    CombinedRole["AGENCY"] = "AGENCY";
    CombinedRole["YALEO_SELF_BOOKING_USER"] = "YALEO_SELF_BOOKING_USER";
    CombinedRole["NEW_COMPANY"] = "NEW_COMPANY";
})(CombinedRole || (CombinedRole = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["TOKEN"] = "token";
})(StorageKey || (StorageKey = {}));
